export default __webpack_public_path__ + "static/media/fridge1-before2.6b3786d1.jpg";